
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DetailsSummaryContainer extends Vue {
  @Prop({ type: String }) readonly btnLabel!: string;
  @Prop({ type: Boolean, default: false }) readonly isDisabled!: boolean;

  showOtherSlot = false;

  showSlotOther() {
    this.showOtherSlot = true;
  }

  hideSlotOther() {
    this.showOtherSlot = false;
  }

  get isOtherSlot() {
    return !!this.$slots.other;
  }
}
